import { axiosInstance } from './apiCommon';
import { PagedResult } from 'types/search-common/PagedResult';
import {
  CertificationBodyListItem,
  CertificationBodySearchRequest,
  IndividualVerifierListItem,
  IndividualVerifierSearchRequest,
} from 'types/verifiers/VerifierModels';

export const searchIndividualVerifiers = async (request: IndividualVerifierSearchRequest): Promise<PagedResult<IndividualVerifierListItem>> =>
  (await axiosInstance.post<PagedResult<IndividualVerifierListItem>>('/api/v1/Verifiers/individual/search', request)).data;

export const getIndividualVerifierOrganisations = async (): Promise<string[]> =>
  (await axiosInstance.get<string[]>('/api/v1/Verifiers/individual/organisations')).data;

export const searchCertificationBodies = async (request: CertificationBodySearchRequest): Promise<PagedResult<CertificationBodyListItem>> =>
  (await axiosInstance.post<PagedResult<CertificationBodyListItem>>('/api/v1/Verifiers/certification-bodies/search', request)).data;

export const getCertificationBodyAccreditedByOptions = async (): Promise<string[]> =>
  (await axiosInstance.get<string[]>('/api/v1/Verifiers/certification-bodies/accredited-by')).data;
